<section class="section-white" *ngIf="featuresData">
  <div class="section-container-inside mar-t-a">
    <div class="section-turbocharge-grid">
      <!------- Global Multi-Currency Account ------->
      @for(feature of featuresData; track $index; let i = $index){
        @if(feature?.fields?.title) {
        <div class="section-turbocharge" [ngClass]="{'section-turbocharge-revert': i % 2 != 0}">
          <div class="your-business-content">
            <div class="revolutionize-team-heading">
              {{ feature?.fields?.title }}
            </div>
            <div
              class="your-business-description mar-t-16 mar-b-24"
              [innerHtml]="feature?.fields?.content | toHtml"
            ></div>
          </div>
          <div class="{{i == 0 ? 'moonstone-100' : (i == 1 ? 'pink-100' : 'orange-100')}} turbocharge-img">
            <figure [ngClass]="{'img-align-b': i == 1}">
              <img
                src="{{ feature?.fields?.image?.[0]?.fields?.file?.url }}"
                alt="{{ feature?.fields?.image?.[0]?.fields?.title }}"
              />
            </figure>
          </div>
        </div>
        }
      }
    </div>
  </div>
</section>
